export default "__VITE_ASSET__21c4371b__"